<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" @click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Generar Envíos</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../assets/parcels.png">
    <div class="content">Generar Envíos</div>
  </h1>
  <div class="ui tabular menu">
    <a class="item" @click="goTo('/generateParcel')">
      Generar un envío manualmente
    </a>
    <a class="item active" @click="goTo('/importParcels')">
      Importar fichero
    </a>
  </div>
  <div v-if="!apmOptions" class="ui active centered inline loader"></div>
  <div v-if="apmOptions" class="ui stackable ">
    <div class="row">
      <div class="ui form">
        <div class="two fields">
          <div class="field">
            <label>Taquilla de destino</label>
            <sui-dropdown class="altuera" :options="apmOptions" placeholder="Taquilla" selection v-model="place_id" />
          </div>
          <div class="field">
            <label>Fichero XLSL <b v-if="ext === 'nacex'">Campos: Barcode, Order, Phone, Email, Agency</b></label>
            <input id="idFile" type="file" class="altuera" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="importFile" @click="removeSelectedFile">
          </div>
        </div>
        <!-- <div id="generate" v-if="dataToImport.length>0" class="ui teal fluid button" v-on:click="generateParcelList()">Generar envíos</div> -->
        <div id="generate" class="ui teal fluid button" v-on:click="generateParcelList()">Generar envíos</div>
      </div>
    </div>
    <br />

    <div id='ok' hidden>
      <div class="ui success message">
        <div class="header">
          Envíos generados correctamente
        </div>
        <p>Los pedidos generados están en verde</p>  
      </div>
      
      <button class="ui basic button" v-on:click="getGeneratedShipments()">
        <i class="cloud download icon"></i>Exportar pedidos
      </button>
      <br />
    </div>

    <div id='ko' class="ui info message" hidden>
      <div class="header">
        Pedidos importados correctamente
      </div>
      <p>Los pedidos que estén en gris no se generaran, porque no tienen número de pedido, agencia o porque les falta el email o el teléfono.</p>  
    </div>
    <br />

    <div v-if="dataToImport.length>0" class="row">
      <h4 class="ui dividing header">Visualización de los datos importados</h4>
      <table class="ui compact table">
        <thead>
          <tr>
            <th>Código de barras</th>
            <th>Albarán</th>
            <th v-if="ext !== 'nacex'">Nombre</th>
            <th>Telefono</th>
            <th>Email</th>
            <th v-if="ext == 'nacex'">Agencia</th>
            <th v-if="comentario">Comentario</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in dataToImport" v-bind:class="data.color">
            <td>{{data.barcode_alt}}</td>
            <td>{{data.refcode}}</td>
            <td v-if="ext !== 'nacex'">{{data.name}}</td>
            <td>{{data.phone}}</td>
            <td>{{data.email}}</td>
            <td>{{data.agencia}}</td>
            <td>{{data.comentario}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
import XLSX from 'xlsx';

export default {
  name: 'ImportParcels',
  data() {
    return {
      user: null,
      pass: null,
      ext: null,
      role: null,
      comentario: false,
      apmOptions: [],
      place_id: null,
      dataToImport: [],
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role
    this.ext = JSON.parse(localStorage.company).ext

    if (this.role === 'master' || (this.role.includes('apiclient') && this.ext !== 'nacex')) {
      this.getUsersApms()
      this.getCredentials()
    } else if (this.ext === 'nacex') {
      this.getUsersApms()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  mounted() {
    document.getElementById("generate").style.display = "none"
  },
  methods: {
    getUsersApms() {
      hapiickApi().post('/v1/users/apms', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(req => {
        let apmsList = JSON.parse(JSON.stringify(req.data.data.apms))
        let resultApm = []

        for (let i = 0; i < apmsList.length; i++) {
          resultApm.push({
            key: apmsList[i].Apt.place_id,
            text: apmsList[i].LanguagesApts[0].name,
            value: apmsList[i].Apt.place_id
          })
        }
        this.apmOptions = resultApm;
        this.place_id = resultApm[0].key;
      })
      .catch(() => console.log('error getting apms'));
    },
    getCredentials() {
      hapiickApi().post('/v2/clients/get-credentials', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => this.setCredentials(request))
      .catch(() => console.log('error getting credentials'))
    },
    setCredentials(req) {
      this.pass = JSON.parse(JSON.stringify(req.data.data.ApiClient.cleveron_pass))
      this.user = JSON.parse(JSON.stringify(req.data.data.ApiClient.cleveron_user))
    },
    removeSelectedFile(oEvent){
      if (oEvent.target.files[0]) {
        document.getElementById("idFile").value = "";
        document.getElementById("ok").style.display = "none"
        document.getElementById("ko").style.display = "none"
        this.dataToImport = [];
      }
    },
    importFile(oEvent) {
      var oFile = oEvent.target.files[0];
      var reader = new FileReader();
      let allFileData = [];
      reader.onload = (e) => {
        var data = e.target.result;
        var cfb = XLSX.read(data, { type: 'binary' });
        cfb.SheetNames.forEach((sheetName) => {
          var oJS = XLSX.utils.sheet_to_json(cfb.Sheets[sheetName]);
          for (var i = 0; i < oJS.length; i++) {
            var parcelInfo = {
              'place_id': this.place_id,
              'phone': oJS[i].Phone ? oJS[i].Phone.toString() : '',
              'email': oJS[i].Email ? oJS[i].Email.toString() : '',
              'barcode_alt': oJS[i].Barcode ? oJS[i].Barcode.toString() : '',
              'refcode': oJS[i].Order ? oJS[i].Order.toString() : '',
              'color': 'txuria',
              'created': true
            };
            if (this.ext === 'nacex') {
              parcelInfo.agencia = oJS[i].Agency ? oJS[i].Agency.toString() : '';
            }
            if (this.ext !== 'nacex') {
              parcelInfo.name = oJS[i].Nombre.toUpperCase();
            }
            if (!oJS[i].Order || (!oJS[i].Phone && !oJS[i].Email) || !oJS[i].Agency || !oJS[i].Barcode) {
              parcelInfo.color = 'red';
              parcelInfo.created = false;
            }
            allFileData.push(parcelInfo);
          }
        });
      };
      this.dataToImport = allFileData
      document.getElementById("ko").style.display = "block"
      document.getElementById("generate").style.display = "block"
      reader.readAsBinaryString(oFile);
    },
    getTodayDate(){
      let today = new Date();
      var utcString = today.toISOString().substring(0,19);
      var year = today.getFullYear()
      var month = (today.getMonth()+ 1).toString().padStart(2,'0');
      var day = today.getDate().toString().padStart(2,'0');
      var hour = today.getHours().toString().padStart(2,'0');
      var minute = today.getMinutes().toString().padStart(2,'0');

      var localDatetime = year + "-" + month + "-" + day + " " + hour + ":" + minute + utcString.substring(16,19); 
      return localDatetime;
    },
    async generateParcelList() {
      if (this.dataToImport.length < 1) {
        this.$swal.fire({
          type: 'info',
          text: 'No hay pedidos para generar, importa un fichero con pedidos',
        })
        return;
      }
      let x = document.getElementById("generate");
      x.classList.add("loading");
      x.disabled = true;
      document.getElementById("ko").style.display = "none"
      
      const dataToImport_orig = [...this.dataToImport];
      let parcels = dataToImport_orig.filter((aux) => (aux.created))
      let generated = []

      this.dataToImport = [];
      for (var i = 0; i < parcels.length; i++) {
        let aa = await this.generateParcel(parcels[i]);
        generated.push(aa);
      }

      this.dataToImport = generated;

      document.getElementById("ok").style.display = "block"
      x.classList.remove("loading");
      document.getElementById("generate").style.display = "none"
    },
    async generateParcel(parcelInfo) {
        let url;
        let body = {
          admin_id: JSON.parse(localStorage.admin).id,
          place_id: parcelInfo.place_id,
          phone: parcelInfo.phone,
          email: parcelInfo.email,
          barcode_alt: parcelInfo.barcode_alt,
          refcode: parcelInfo.refcode,
        }

        if ((this.role.includes('apiclient') && this.ext !== 'nacex')) {
          url = '/webservices/new_client_shipment';
          body.name = parcelInfo.name
        } else if (this.ext === 'nacex') {
          url = '/v1/users/shipments/add'
          body.key = this.ext
          body.agencia = parcelInfo.agencia
        }

        const request = await hapiickApi().post(url, {
          admin_id: JSON.parse(localStorage.admin).id,
          parcelInfo: body
        });

        const { status, error, shipment } = request.data;

        if (error) {
          this.comentario = true
          let msg = ''
          if (error === "Duplicated barcode") {
            msg = "Pedido duplicado"
          } else if (error === "Provider api error") {
            msg = "Error desconocido"
          } else {
            msg = error
          }
          parcelInfo.generate = false
          parcelInfo.comentario = msg
          parcelInfo.date = this.getTodayDate()
          return parcelInfo;
        } else {
          parcelInfo.color = 'yes'
          parcelInfo.generate = true
          parcelInfo.comentario = ''
          parcelInfo.date = this.getTodayDate()
          return parcelInfo;
        }
    },
    getGeneratedShipments(){
      this.exportToCsv(this.dataToImport);
    },
    exportToCsv(allPackages) {
      let packs = false;
      if (allPackages.length>0) {
        let filename = 'Shipments_'+this.getTodayDate()+'.csv';
        if ( allPackages[0].from !== 'no encontrado') {
          var csv = [];
          csv.push('Locker,Barcode,Order,Phone,Email,Agency,Generated,Comment,Date');
          for (var i = 0; i < allPackages.length; i++) {
            let apm_name = this.apmOptions.find((e) => (e.key === allPackages[i].place_id)).text
            csv.push(
              (apm_name)+','+
              (allPackages[i].barcode_alt)+','+
              (allPackages[i].refcode)+','+
              (allPackages[i].phone)+','+
              (allPackages[i].email)+','+
              (allPackages[i].agencia)+','+
              (((allPackages[i].generate)) ? 'Si' : 'No' )+','+
              (allPackages[i].comentario)+','+
              allPackages[i].date
            );
          }
          // download csv file
          this.downloadCSV(csv.join("\n"), filename)
          packs = true;
        }
      }
      if (!packs) {
        this.$swal({
          type: 'info',
          text: 'No hay pedidos'
        })
      }
    },
    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;
      if (window.Blob == undefined || window.URL == undefined || window.URL.createObjectURL == undefined) {
        alert("Your browser doesn't support Blobs");
        return;
      }

      csvFile = new Blob([csv], {
        type: "text/csv"
      });
      downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
    goTo(where) {
      this.$router.push(where)
    }
  }
}
</script>
<style scoped>
.txuria{
  background-color: white;
}
.yes, .yes:hover{
  background-color: var(--var-color);
}

.red, .red:hover{
  background-color: #bdbdbd /*#db5159*/
}
.altuera{
  height: 42px;
}
</style>



// WEBPACK FOOTER //
// src/components/importParcels.vue